import { render, staticRenderFns } from "./TerrainBuilder.vue?vue&type=template&id=6e0686be&scoped=true"
import script from "./TerrainBuilder.vue?vue&type=script&lang=js"
export * from "./TerrainBuilder.vue?vue&type=script&lang=js"
import style0 from "./TerrainBuilder.vue?vue&type=style&index=0&id=6e0686be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0686be",
  null
  
)

export default component.exports